import { cn } from 'lib/utils'
import { forwardRef, TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string
}

export const CustomTextarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = '', error, ...props }, ref) => {
    return (
      <div className="tw-w-full">
        <textarea
          ref={ref}
          className={cn(
            'tw-w-full tw-px-4 tw-py-2 tw-text-sm tw-bg-white tw-border-solid tw-border tw-rounded-md tw-transition-colors tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-min-h-[120px] tw-resize-y',
            error ? 'tw-border-red-500' : 'tw-border-gray-300',
            className
          )}
          {...props}
        />
      </div>
    )
  }
)

CustomTextarea.displayName = 'CustomTextarea'
